import {
  OpenMarketProductStatusType,
  ProductStatusType,
  TireConditionType,
} from '../../../constants/product/product.constant';
import { customAxios } from '../../common/customAxios';
import { ITractorImage } from './postUsersSellTractors';

export interface IUserSellTractorsReqBody {
  manufacturedYear?: number;
  operationTime?: number;
  option?: string | null;
  optionDetails?: string[] | null;
  workingMachine?: string | null;
  workingMachineDetails?: string[] | null;
  hopeSellingPrice?: number;
  tractorImages?: ITractorImage[];
  location?: string;
  directImportYn?: boolean | null;
  priceNegotiationYn?: boolean | null;
  frontTireCondition?: TireConditionType | null;
  rearTireCondition?: TireConditionType | null;
  needRepairParts?: string[] | null;
  replacedParts?: string[] | null;
  information?: string;
  approvalStatus: OpenMarketProductStatusType;
  status: ProductStatusType;
}

interface patchUserSellTractorsParams {
  sellTractorId: string;
  reqBody: IUserSellTractorsReqBody;
}

export const patchUserSellTractors = ({ sellTractorId, reqBody }: patchUserSellTractorsParams): Promise<void> => {
  return customAxios.patch(`/user-sell-tractors/mine/${sellTractorId}`, reqBody);
};
